 
// Disabling prop-types for column/data which are objects built by react-table library

import { useMemo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { SearchFilter, SelectFilter, SelectFilterWrapper } from './Base';

const Filter = ({ column }) => {
  const inputRef = useRef(null);
  const { preFilteredRows, filterOptions, setFilter, filterValue } = column;
  const { type } = filterOptions;
  const options = useMemo(() => {
    if (type !== 'select') return [];

    const optionsSet = new Set();
    if (typeof filterOptions.options === 'function') {
      preFilteredRows.forEach((row) => {
        optionsSet.add(filterOptions.options(row.original));
      });
    } else if (typeof filterOptions.options === 'string') {
      preFilteredRows.forEach((row) => {
        optionsSet.add(row.original[filterOptions.options]);
      });
      optionsSet.add(preFilteredRows.map());
    } else {
      return filterOptions.options;
    }

    return [...optionsSet.values()];
     
  }, [preFilteredRows, filterOptions.options, type]);

  // On mount:
  // - focus input ref
  // - register filter reset on unmount
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    return () => setFilter(undefined);
     
  }, []);

  const renderOptions = () => {
    const optionEls = options.map((opt) => {
      const [label, value] = Array.isArray(opt) ? opt : [opt, opt];
      return (
        <option value={value} key={value}>
          {label}
        </option>
      );
    });

    return optionEls;
  };

  return type === 'select' ? (
    <SelectFilterWrapper>
      <SelectFilter
        value={filterValue}
        onChange={(e) => setFilter(e.target.value || undefined)}
        onClick={(e) => e.stopPropagation()}
        ref={inputRef}
      >
        <option value="">All</option>
        {renderOptions()}
      </SelectFilter>
    </SelectFilterWrapper>
  ) : (
    <SearchFilter
      placeholder={column.filterOptions.placeholder}
      value={filterValue || ''}
      onChange={(e) => setFilter(e.target.value || undefined)}
      onClick={(e) => e.stopPropagation()}
      ref={inputRef}
    />
  );
};

Filter.propTypes = {
  inputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
};

export default Filter;
